module.exports = function() {
  return new Worker(__webpack_public_path__ + "6013b3fdb947e96d2a5b.worker.js");
};